import React from 'react';
import { useTranslations } from '../../hooks/useTranslations';
import { createListSection } from '../ListSection';
import { SectionItem } from '../SectionItem';
import { Highlight } from '../Highlight';
import { SectionItemEventDetails } from '../SectionItemEventDetails';
function RaceElement({ value, highlights, position }) {
    var _a, _b, _c, _d, _e, _f;
    const { t } = useTranslations();
    const sport = ((_a = value.sport) === null || _a === void 0 ? void 0 : _a.slug) || 'event';
    const href = `${sport}/racecard/${encodeURIComponent(value.id)}/${value.slug}`;
    const competitionElement = value.name
        .toLowerCase()
        .includes(`${(_b = value.competition) === null || _b === void 0 ? void 0 : _b.name}`.toLowerCase()) ? null : (React.createElement(React.Fragment, null,
        React.createElement(Highlight, { highlighted: highlights['competition.name'], content: (_c = value.competition) === null || _c === void 0 ? void 0 : _c.name }),
        ' | '));
    const description = [
        value.race.distance,
        value.race.class && value.race.class !== '-' && value.race.class,
        value.race.typeDescription,
        value.race.goingDescription && `${t('raceGoing')}: ${value.race.goingDescription}`,
    ]
        .filter(Boolean)
        .join(', ');
    const searchSection = 'Races';
    const inPlay = value.isInPlay;
    return (React.createElement(SectionItem, { internalLink: true, expectedTitle: 1, expectedDescription: 2, href: href, id: value.id, searchSection: searchSection, position: position, inPlay: inPlay },
        React.createElement(SectionItemEventDetails, { competitionName: (_d = value.competition) === null || _d === void 0 ? void 0 : _d.name, sportId: (_e = value.sport) === null || _e === void 0 ? void 0 : _e.id, startDateTime: value.startTime }),
        React.createElement("div", { className: "WhSearch-SectionItem__title" },
            React.createElement(Highlight, { highlighted: highlights.name, content: value.name })),
        React.createElement("div", { className: "WhSearch-SectionItem__description" },
            description,
            value.competition || value.sport ? React.createElement("br", null) : null,
            competitionElement,
            React.createElement(Highlight, { highlighted: highlights['sport.name'], content: (_f = value.sport) === null || _f === void 0 ? void 0 : _f.name }))));
}
export const RaceSection = createListSection(RaceElement, {
    title: 'sectionRacesTitle',
});
//# sourceMappingURL=RaceSection.js.map